
document.addEventListener('DOMContentLoaded', function () {
  const pattern = /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i
  if (!document.querySelector("[data-section-type='account']"))
    return

  const addressForms = document.querySelectorAll("[data-section-type='account'] form")
  if (!addressForms)
    return

  for (let addressForm of addressForms) {
    const addressInput = addressForm["address[address1]"]
    const addressInput2 = addressForm["address[address2]"]

    if (!addressInput) {
      return
    }

    addressInput.addEventListener('change', validateAddressInput)
    addressInput2.addEventListener('change', validateAddressInput)

    function validateAddressInput(event) {
      if (pattern.test(normalizeDiacritics(event.target.value))) {
        event.target.value = ""
        addressForm.querySelector(".alert")?.remove()
        const errorMessage = document.querySelector('#po_box_error').content.cloneNode(true)
        addressForm.prepend(errorMessage)
        event.target.focus()
        addressForm.closest(".modal__dialog").scrollTop = 0
      }
    }

    function normalizeDiacritics(string) {
      var string;

      var diacritics = [
        /[\300-\306]/g, /[\340-\346]/g,  // A, a
        /[\310-\313]/g, /[\350-\353]/g,  // E, e
        /[\314-\317]/g, /[\354-\357]/g,  // I, i
        /[\322-\330]/g, /[\362-\370]/g,  // O, o
        /[\331-\334]/g, /[\371-\374]/g,  // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
      ];

      var chars = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

      for (var i = 0; i < diacritics.length; i++) {
        string = string.replace(diacritics[i], chars[i]);
      }

      return string;
    }
  }
})
